import { BehaviorSubject } from 'rxjs'
import {Component, OnInit, Output, ViewChild, ElementRef, Input} from '@angular/core'

@Component({
  selector: 'app-search-field',
  templateUrl: './search-field.component.html',
  styleUrls: ['./search-field.component.scss']
})
export class SearchFieldComponent implements OnInit {
  @ViewChild ('search') input: ElementRef<HTMLInputElement>;
  @ViewChild ('button') button: ElementRef<HTMLButtonElement>;
  @Input () placeholder: string = '';
  @Input () butonVisible: boolean = false;
  @Output ('change') change = new BehaviorSubject<any>('');
  @Output ('submit') submit = new BehaviorSubject<any>('');

  constructor() { }

  ngOnInit() {
    this.input.nativeElement.addEventListener('keyup',
      event => {
        this.change.next(this.input.nativeElement.value)
        if (event.key === 'Enter') {
          this.submit.next(this.input.nativeElement.value)
        }
      }
    )
    if(this.butonVisible){
      this.button.nativeElement.addEventListener('click',
          event => {
              this.change.next(this.input.nativeElement.value)
              this.submit.next(this.input.nativeElement.value)
          }
      )
    }
  }

}
